import { create } from 'zustand'
import { supabase } from '@/lib/supabase/client'

interface EphiState {
  ephiCount: number
  loading: boolean
  checkEphiCount: (userId: string) => Promise<void>
}

export const useEphiStore = create<EphiState>((set, get) => ({
  ephiCount: 0,
  loading: false,
  checkEphiCount: async (userId: string) => {
    // Evita múltiplas chamadas simultâneas
    if (get().loading) return

    try {
      set({ loading: true })

      const { data, error } = await supabase
        .from('profiles')
        .select('ephi_count')
        .eq('id', userId)
        .single()

      if (error) throw error

      const newCount = data?.ephi_count ?? 0
      
      // Só atualiza se o valor realmente mudou
      if (get().ephiCount !== newCount) {
        set({ ephiCount: newCount })
      }
    } catch (error) {
      console.error('Erro ao verificar quantidade de ephis:', error)
      set({ ephiCount: 0 })
    } finally {
      set({ loading: false })
    }
  }
})) 